import { render, staticRenderFns } from "./OwnerStaff.vue?vue&type=template&id=41c2855f&"
import script from "./OwnerStaff.vue?vue&type=script&lang=ts&"
export * from "./OwnerStaff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports